import { Component, ViewContainerRef, ChangeDetectionStrategy, effect, input } from '@angular/core';
import { ChatMessage } from '../digital-assistant.model';
import { ComponentMappingService } from './chat/services/component-mapping.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-dynamic-chat-loader',
  template: ` <ng-container #container></ng-container> `,
  styles: [],
})
export class DynamicLoaderComponent {
  readonly message = input<ChatMessage>();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private mappingService: ComponentMappingService
  ) {
    effect(() => {
      const message = this.message();
      if (!message || !message.type) {
        return;
      }
      const ComponentClass = this.mappingService.getComponent(message.type ?? 'text');
      if (ComponentClass) {
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(ComponentClass);
        componentRef.setInput('content', message.content);
      }
    });
  }
}
